/**
 * The label for a code the backend sends: our translation when we have one, else the server's own label,
 * else the code made readable (underscores to spaces). A code this build doesn't know never shows as a raw
 * message key. Pure, so node:test can load it.
 */
export function resolveCodeLabel(
  code: string,
  translate: (code: string) => string | null,
  serverLabel?: string | null,
): string {
  return translate(code) ?? (serverLabel || code.replace(/_/g, ' '))
}
